<template>

  <!-- Modal -->
  <div class="modal fade" id="view-admin-announcement-modal" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
      <div class="modal-content" style="min-height: 200px">
        <div class="modal-header text-center">
          <h3 class="modal-title w-100 font-weight-bold" id="exampleModalCenterTitle" v-if="adminAnnouncementList[0]">
            {{ adminAnnouncementList[0].title }}
          </h3>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body" style="white-space: pre-line">

            <ol style="text-align: left">

              <template v-if="adminAnnouncementList[0]">
                {{ adminAnnouncementList[0].message }}
              </template>

              <br>
              <br/> <p class="mb-1 font-weight-bold">Attachments: </p>
              <template v-if="adminAnnouncementList[0]">
                <ul v-for="(announcementAttachment, index) in adminAnnouncementList[0].announcement_attachment" :key="index">
                    <li>
                      <a type="button" class="text-primary"
                         title="View Attachment"
                         @click="loadAttachmentFile(announcementAttachment.id, index, announcementAttachment.name)"
                      >{{ announcementAttachment.name }}</a>

<!--                      <a :download="announcementAttachment.name"-->
<!--                         :href='announcementFileAttachment'-->
<!--                         @click="downloadAttachmentFile(announcementAttachment.id)"-->
<!--                      >-->
<!--                        Download Manual-->
<!--                      </a>-->
                    </li>
                </ul>
              </template>

            </ol>


<!--          <div class=" table-responsive text-small mb-3">-->
<!--            <table class="table table-hover table-bordered table-template-1 text-small sticky-header">-->
<!--              <thead>-->
<!--              <tr>-->
<!--                <th class="col-type-width">Attachment Name</th>-->
<!--                <th>File</th>-->
<!--                <th></th>-->
<!--              </tr>-->
<!--              </thead>-->

<!--              <tbody>-->
<!--              <tr v-for="(expenseAttachment, index) in adminAnnouncementList" :key="index">-->

<!--                <td style="text-align: center;">-->
<!--                  <span class="bg-light-danger font-weight-bolder">{{ expenseAttachment.title }}</span>-->
<!--                </td>-->
<!--                <td style="text-align: center;">-->
<!--                  <a type="button" class="text-primary"-->
<!--                     title="View Attachment"-->
<!--                  >View File</a>-->
<!--                </td>-->
<!--                <td style="text-align: center;">-->
<!--                  <button type="button"-->
<!--                          class="btn btn-outline-danger btn-sm btn-xs font-weight-bold"-->
<!--                  >-->
<!--                    &lt;!&ndash;                    <i class="fas fa-minus"></i>&ndash;&gt;-->
<!--                    ✖-->
<!--                  </button>-->
<!--                </td>-->
<!--              </tr>-->

<!--              <tr v-if="adminAnnouncementList ? (adminAnnouncementList.length == 0) : '' ">-->
<!--                <td colspan="100%" class="bg-light-danger font-weight-bolder">-->
<!--                  <p class="text-center mt-3">No attachments found</p>-->
<!--                </td>-->
<!--              </tr>-->

<!--              </tbody>-->
<!--            </table>-->

<!--          </div>-->


        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
<!--          <button type="button" class="btn btn-primary">Save changes</button>-->
        </div>
      </div>
    </div>
  </div>

</template>

<script>

import {mapActions, mapGetters} from 'vuex';
import {vueAppMixin} from '@/mixins/vueAppMixin';
import {FileService} from "@/services/FileService";

export default {
  name: "AdminAnnouncementModal",

  /** mixins **/
  mixins: [vueAppMixin],

  /** props **/
  props: {},

  /** data **/
  data () {
    return {
      announcementFileAttachment: '',
    }
  },

  /** methods**/
  methods: {
    ...mapActions([
        'getAdminAnnouncement',
        'getAdminAnnouncementAttachmentFile',
        'getAdminAnnouncementAttachment',
    ]),

    async loadAttachmentFile(announcementId, attachmentIndex, name) {
      let params = {
        adminAnnouncementAttachmentId: announcementId
      }
      // console.log(announcementId, 'announcementId')
      let adminAnnouncementAttachmentFile = await this.getAdminAnnouncementAttachmentFile(params);

      let fileData = await this.getAdminAnnouncementAttachment(params);
      // console.log(fileData);
      // this.announcementFileAttachment = 'data:application/pdf;base64,'+fileData;
      const download = document.createElement('a');

      download.href=FileService.base64FileToBlobUrl(fileData);
      download.download = name + '.pdf';
      download.click();
      download.remove();

      // console.log(this.announcementFileAttachment, 'this.announcementFileAttachment')

      // if (adminAnnouncementAttachmentFile) {
      //   this.pdfViewer(name, adminAnnouncementAttachmentFile);
      // }
    },


    async downloadAttachmentFile(announcementId) {
      let params = {
        adminAnnouncementAttachmentId: announcementId
      }
      let fileData = await this.getAdminAnnouncementAttachment(params);
      this.announcementFileAttachment = 'data:application/pdf;base64,'+fileData;
      console.log(this.announcementFileAttachment, 'this.announcementFileAttachment')


    },




  },

  /**  computed  **/
  computed: {
    ...mapGetters([
        'adminAnnouncementList',
        'adminAnnouncementAttachment',
    ])
  },

  /** mounted **/
  mounted () {
  },

  /** created **/
  created () {
    this.getAdminAnnouncement();
  },

  /** watch **/
  watch: {},

  /** destroyed **/
  destroyed () {
  },


}
</script>

<style scoped>

</style>